/* Menu mobilne nagłówka BrainJell.
   Design sterował tym stanem Reactowym (menuOpen) — tutaj web component,
   zgodnie z decyzją architektoniczną: vanilla JS / web components, nie React. */

class BjHeader extends HTMLElement {
  connectedCallback() {
    this.burger = this.querySelector('[data-bj-burger]');
    this.menu = this.querySelector('[data-bj-menu]');
    if (!this.burger || !this.menu) return;

    this.onToggle = this.onToggle.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onNavigate = this.onNavigate.bind(this);

    this.burger.addEventListener('click', this.onToggle);
    this.addEventListener('keydown', this.onKeydown);
    this.menu.addEventListener('click', this.onNavigate);
  }

  disconnectedCallback() {
    this.burger?.removeEventListener('click', this.onToggle);
    this.removeEventListener('keydown', this.onKeydown);
    this.menu?.removeEventListener('click', this.onNavigate);
  }

  get open() {
    return this.burger.getAttribute('aria-expanded') === 'true';
  }

  set open(value) {
    this.burger.setAttribute('aria-expanded', String(value));
    this.menu.hidden = !value;
  }

  onToggle() {
    this.open = !this.open;
  }

  onKeydown(event) {
    if (event.key !== 'Escape' || !this.open) return;
    this.open = false;
    this.burger.focus();
  }

  // Kliknięcie w link zamyka menu — w one-pagerze linki to kotwice,
  // więc nawigacja nie przeładowuje strony i menu zostałoby otwarte.
  onNavigate(event) {
    if (event.target.closest('a')) this.open = false;
  }
}

if (!customElements.get('bj-header')) {
  customElements.define('bj-header', BjHeader);
}
